import { ContainerSelect } from './styles';
import { Select, SelectProps } from 'antd';

export const ASelect: React.FC<SelectProps> = ({ ...res }) => {
  return (
    <ContainerSelect>
      <Select {...res} />
    </ContainerSelect>
  );
};
